export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.Realtive_types) {
        return {...state, ...payload.Realtive_types};
      }
      return state;
    }
  }
};
